import Header from '../components/Header';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';
import HeroSlider from '../components/HeroSlider';
import AboutSection from '../components/AboutSection';
import ClientsCarousel from '../components/ClientsCarousel';
import FeaturesSection from '../components/FeaturesSection';
import ServicesSection from '../components/ServicesSection';
import GallerySection from '../components/GallerySection';
import TestimonialsSection from '../components/TestimonialsSection';
import ContactSection from '../components/ContactSection';

const Home = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <WhatsAppButton />
      <main>
        <HeroSlider />
        <AboutSection />
        <ClientsCarousel />
        <FeaturesSection />
        <ServicesSection />
        <GallerySection />
        <TestimonialsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
